const formatters = [
  { pattern: /'/g, replacement: "’" },
  { pattern: /\s([^\s<]+)\s*$/g, replacement: "\u00A0$1" },
];

export const formatted = (a) =>
  formatters.reduce((a, f) => a?.toString().replace(f.pattern, f.replacement), a);
